import React, { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Button, Typography, Box } from "@mui/material";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const scopes = ["User.Read.All", "Files.ReadWrite.All"];

const LoginPage = () => {
  const { instance } = useMsal(); // Get the initialized MSAL instance
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  const login = useCallback(() => {
    instance
      .loginRedirect({
        scopes,
      })
      .catch((error) => {
        console.error("Login failed:", error);
      });
  }, [instance]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/"); // Redirect to the home page after successful login
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Typography variant="h4" gutterBottom>
        Login with Microsoft
      </Typography>
      <Button variant="contained" color="primary" onClick={login}>
        Sign in with Microsoft
      </Button>
    </Box>
  );
};

export default LoginPage;
